<template>
    <div>
        <div style="padding-top: 20px">
            <el-button class="el-icon-refresh" type="primary" plain @click="getList()"> 刷新</el-button>
            <strong style="margin-left: 20px" v-text="`在线玩家总数：${userOnlineATList.total}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userOnlineATList.beanList"
                    @expand-change="expandChange"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column type="expand">
                    <div slot-scope="scope" class="table-expand">
                        <span class="item" v-text="`总保险：${scope.row.totalInsurance}记分牌`"></span>
                        <span class="item" v-text="`总手数：${scope.row.totalHand}`"></span>
                        <span class="item" v-text="`总房间数：${scope.row.totalGame}`"></span>
                        <span class="item" v-text="`总带入次数：${scope.row.totalTakeIn}`"></span>
                        <span class="item" v-text="`JP贡献：${scope.row.totalDedicationJp}记分牌`"></span>
                        <span class="item" v-text="`JP奖励：${scope.row.totalJpReward}记分牌`"></span>
                        <span class="item" v-text="`奥马哈总积分：${scope.row.omahaProfit}记分牌`"></span>
                        <span class="item" v-text="`AOF总积分：${scope.row.aofProfit}记分牌`"></span>
                        <span class="item" v-text="`总赠送金豆：${scope.row.totalGiftChip}金豆`"></span>
                        <span class="item" v-text="`玩家ID：${scope.row.userRandomId}`"></span>
                        <span class="item" v-text="`所属俱乐部：${scope.row.clubName}`"></span>
                        <span class="item" v-text="`所属联盟：${scope.row.tribeName}`"></span>
                        <span class="item" v-text="`UCV：${scope.row.ucv}记分牌`"></span>
                        <span class="item" v-text="`德州入池率：${scope.row.dzPoolRate}%`"></span>
                        <span class="item">最近带入地点：
                            <template v-if="scope.row.currentEquipment === 'simulator'">虚拟定位</template>
                            <location-to-city v-else :location="`${scope.row.bringLongitude},${scope.row.bringLatitude}`"/>
                        </span>
                        <span class="item" v-text="`IP关联：${scope.row.firstLevelIpRelevance}`"></span>
                        <span class="item" v-text="`设备关联：${scope.row.firstLevelEquipmentRelevance}`"></span>
                    </div>
                </el-table-column>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" min-width="150" align="center" prop="userNickname"/>
                <el-table-column label="游戏类型" min-width="150" align="center" prop="roomPath">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roomPath==61">德州</span>
                        <span v-else>AOF</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" min-width="150" align="center">
                    <template slot-scope="scope">
                        {{scope.row.userType | userTypeName}}
                    </template>
                </el-table-column>
                <el-table-column label="近7天的盈亏环比" min-width="150" align="center">
                    <template slot-scope="scope">{{(scope.row.profitLossRatio * 100) | roundNumber}}%</template>
                </el-table-column>
                <el-table-column label="所属俱乐部" min-width="180" align="center" prop="clubName"/>
                <el-table-column label="当前房间" min-width="120" align="center" prop="currentRoomName"/>
                <el-table-column label="房间盲注级别" min-width="120" align="center">
                  <template slot-scope="scope">{{scope.row.blind|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="德州总积分" min-width="150" align="center" prop="dzProfit"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="userOnlineATList.total"
                @current-change="getList($event)"
                :current-page="currentPage"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('userOnline', ['userOnlineATList']),
        },
        created() {
            this.getList();
        },
        filters: {
            roundNumber(num) {
                return Math.round(num)
            },
            userTypeName(type) {
                let arr = ['中小级别盈利型', '中小级别均衡型', '中小级别大鱼型', '大级别盈利型', '大级别均衡型', '大级别大鱼型'];
                return arr[type - 1];
            }
        },
        methods: {
            ...mapActions('userOnline', ['getUserOnlineATList','getUserOnlineExpand']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getUserOnlineATList({
                    page,
                    soryDataType: 0,
                    sortType: '',
                    userLevel: [],
                    userRandomId: ''
                }).then(() => {
                    this.loading = false
                })
            },
            expandChange(row, expandedRows) {
                expandedRows.forEach(item => {
                    if (item.userId === row.userId) {
                        this.loading = true;
                        this.getUserOnlineExpand(row.userId).then(res => {
                            Object.assign(row, res.data);
                            this.loading = false;
                        })
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .table-expand {
        .item {
            display: inline-block;
            padding: 2px 20px;
        }
    }
</style>